<script setup lang="ts">
/**
 * Wrap a `v-if`'d `.stamp`: when it appears on a sheet that is already on
 * screen (a card becoming OWNED, an order CLAIMED) it is slammed, not
 * swapped in. Stamps present when the sheet opens are not animated.
 */
import { slamStamp } from './stamp';
</script>

<template>
  <Transition :css="false" @enter="slamStamp">
    <slot />
  </Transition>
</template>
